import { TableColumn } from "@/components/Table/Table";

/**
 * Default column options for columns that should be hidden by default
 */
export const DEFAULT_COLUMN_OPTIONS_HIDE = {
	width: "fit-content" as const,
	hideable: true,
	moveable: true,
	show: false,
} satisfies Partial<TableColumn>;

/**
 * Default column options for columns that should be shown by default
 */
export const DEFAULT_COLUMN_OPTIONS_SHOW = {
	width: "fit-content" as const,
	hideable: true,
	moveable: true,
	show: true,
} satisfies Partial<TableColumn>;

/**
 * Creates a simple text column with default options
 */
export const createSimpleColumn = (config: {
	title: string;
	uid: string;
	show?: boolean;
	render: TableColumn["render"];
}): TableColumn => ({
	...(config.show ? DEFAULT_COLUMN_OPTIONS_SHOW : DEFAULT_COLUMN_OPTIONS_HIDE),
	title: config.title,
	uid: config.uid,
	render: config.render,
});
